import { Injectable, Injector } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import {CLiCSService} from "../clics.service";
import {PageControllerProvider} from "../page-controller/page-controller";

@Injectable({
  providedIn: 'root'
})
export class ClientGuardService implements CanActivate {
  clicsService: CLiCSService = null;
  pageController: PageControllerProvider = null;

  constructor(
    private router: Router,
    private injector: Injector
  ) {
    this.clicsService = this.injector.get(CLiCSService);
    this.pageController = this.injector.get(PageControllerProvider);
  }

  // Only permit access to certain pages if there is a client selected
  // NOTE: checks logged in status first so can be used in place of AuthGuardService
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.clicsService.isLoggedIn() == false) {
      this.router.navigate((['/login']));
      return false;
    }
    if (this.clicsService.isSignedOn() == false) {
      this.router.navigate((['/signon']));
      return false;
    }
    if (!this.clicsService.current_salon) {
      this.router.navigate((['/salonselect']));
      return false;
    }
    // Must have a client selected
    if (!this.clicsService.current_user || this.clicsService.current_user.getClient() == null) {
      this.router.navigate((['/clients']));
      return false;
    }
    return true;
  }
}
